import type { ButtonProps } from '../../types';

export default function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  type = 'button',
  onClick,
  children,
  className = '',
  icon,
  iconPosition = 'left',
}: ButtonProps) {
  const classNames = [
    'button',
    `button--${variant}`,
    `button--${size}`,
    fullWidth && 'button--full-width',
    loading && 'button--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classNames}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? (
        <span className="button__spinner" />
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <span className="button__icon">{icon}</span>
          )}
          <span className="button__text">{children}</span>
          {icon && iconPosition === 'right' && (
            <span className="button__icon">{icon}</span>
          )}
        </>
      )}
    </button>
  );
}
